import { getBlockType } from "./App";
import Block from "./components/Block/Block";
import { BlockContainer } from "./styles";
import { GameHistoryRow } from "@lindar-joy/goosicorn-quickies-library";

interface IGemsGameRoundDetails {
    bet: number;
    currentLevel: number;
    realWinnings: number;
    currentWinnings: number;
    difficultyLevel: number;
    discoveredPanel: string[];
    resultPanel: string[];
    playerPicks: number[];
    stateStack: string[];
    gameRoundId: string;
}

export const GameHistoryRenderer = (gameRound: IGemsGameRoundDetails) => {
    console.log(gameRound);
    return <div>
        <div></div>
        <GameHistoryRow><div>Mine count</div><div>{ gameRound.difficultyLevel }</div></GameHistoryRow>
        <BlockContainer>
            {gameRound.resultPanel.map((blockConfig, index) => (
                (
                    <Block
                        onClick={() => {}}
                        id={index}
                        key={ index }
                        mineCount={ 0 }
                        type={ getBlockType(false, blockConfig, gameRound.playerPicks.includes(index), true) } 
                        bet={ gameRound.bet }
                    />
                )
            ))}
        </BlockContainer>
        </div>
}
